import React from "react";
import { motion } from "framer-motion";
import { Construction, LogOut, Wrench } from "lucide-react";
import { Button, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../slice/mainSlice";
import { session } from "../../services/session";

const { Title, Paragraph } = Typography;

const UnderMaintenance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    session.delete();
    dispatch(logout());
    navigate("/auth");
  };

  return (
    <div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#06283D] via-[#0A4D68] to-[#1363DF] text-white">
      {/* Decorative background shapes */}
      <div className="absolute -left-20 -top-20 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="absolute -bottom-20 -right-20 h-80 w-80 rounded-full bg-cyan-500/10 blur-3xl" />

      {/* Main Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="z-10 flex w-full max-w-lg flex-col items-center px-6 text-center"
      >
        {/* Animated Icon Container */}
        <div className="relative mb-8 flex h-28 w-28 items-center justify-center rounded-2xl bg-white/10 shadow-xl backdrop-blur-md">
          <motion.div
            animate={{ rotate: [0, 15, -15, 0] }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute"
          >
            <Construction className="h-16 w-16 text-cyan-300" />
          </motion.div>
          <motion.div
            animate={{ y: [0, -5, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.5,
            }}
            className="absolute right-3 top-3"
          >
            <Wrench className="h-6 w-6 text-yellow-300" />
          </motion.div>
        </div>

        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <Title
            level={2}
            className="!font-montserrat font-bold tracking-wide !text-white"
            style={{ fontSize: "2rem", marginBottom: "1rem" }}
          >
            Texnik ishlar olib borilmoqda
          </Title>
        </motion.div>

        {/* Description / Notice */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <Paragraph className="!font-sans text-base leading-relaxed text-blue-100/80">
            Hurmatli foydalanuvchi, ayni paytda Ombor Menejeri tizimida texnik
            va profilaktika ishlari olib borilmoqda. Tizimdan foydalanish vaqtincha
            cheklangan.
          </Paragraph>
          <Paragraph className="!font-sans text-sm text-cyan-200/70">
            Keltirilgan noqulayliklar uchun uzr so'raymiz. Tez orada xizmat
            ko'rsatishni davom ettiramiz.
          </Paragraph>
        </motion.div>

        {/* Animated Progress Bar */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "80%" }}
          transition={{ duration: 1.5, delay: 0.6 }}
          className="my-8 h-[4px] rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 shadow-lg shadow-cyan-500/20"
        />

        {/* Action Button */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          <Button
            type="primary"
            size="large"
            icon={<LogOut className="h-4 w-4 mr-2 inline" />}
            onClick={handleLogout}
            className="!font-montserrat h-12 rounded-xl bg-white/10 px-8 text-base font-semibold text-white border-white/20 hover:!bg-white/20 hover:!border-white/40 shadow-lg transition-all duration-300"
          >
            Tizimdan chiqish
          </Button>
        </motion.div>
      </motion.div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.5 }}
        transition={{ delay: 1 }}
        className="absolute bottom-6 font-sans text-xs tracking-wider text-blue-200/50"
      >
        Business Intelligence Solutions® 2026
      </motion.div>
    </div>
  );
};

export default UnderMaintenance;
